
import { IArticle, ISort } from '@/store/state';
import axios from 'axios';
import qs from 'query-string';

const headers = {
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
}

export interface ISearchParams {
    query: string;
    categories: any[],
    date: {
        start: string,
        end: string
    }
    page: number,
    sort: ISort
}

interface ISearchReturnObject {
    news: IArticle[],
    total: number,
}   

// Used in searchAction (in actions.ts)
export const search = (searchURL: string, params: ISearchParams): Promise<ISearchReturnObject> => {
    let url = `${searchURL}&${qs.stringify({
        query: params.query || '*',
        categories: JSON.stringify(params.categories),
        start: new Date(params.date.start).getTime(),
        end: new Date(params.date.end).getTime(),
        page: params.page,
        sort: JSON.stringify(params.sort)
    })}`

    return axios.get(url, { headers })
        .then((response:any) => {
            return response.data
        })
        .catch((searchError:any) => {
            console.error({
                searchError
            })
            return {} as ISearchReturnObject
        })
}
